var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",attrs:{"changesFromFilter":_vm.changesFromFilter},on:{"filter:config":(val) => _vm.$emit('filter:config', val),"initial:active_filter":(val) => _vm.$emit('initial:active_filter', val)}})
}
var staticRenderFns = []

export { render, staticRenderFns }